import { useRouteError } from 'react-router-dom'

// Route-level error boundary: catches render/loader errors so an unexpected
// failure shows a friendly card instead of a blank screen.
export function ErrorBoundary() {
  const error = useRouteError()
  console.error(error)
  return (
    <div style={{ minHeight: '100%', display: 'grid', placeItems: 'center', padding: 24 }}>
      <div className="card" style={{ maxWidth: 440, textAlign: 'center' }}>
        <div className="page-title">Something went wrong</div>
        <p style={{ color: 'var(--gray)', margin: '8px 0 16px' }}>
          An unexpected error occurred. Reloading usually fixes it.
        </p>
        <button className="btn btn-primary" onClick={() => location.reload()}>
          Reload
        </button>
      </div>
    </div>
  )
}
